const menu = require('../../../../../components/menu/menu')

export function start(detail, htmlFc) {
      const menuElements = menuBody[detail.id]

      if (!menuElements) { return }

      menuElements.forEach((element) => element.start())
      detail.html = menuElements
      detail.act = 'show'
      menu.start(detail)
}

const menuBody = {
      fullcontOptions: [{
            text: '',
            svg: 'update',
            class: 'green',
            dataDetail: '',
            start: function () {
                  this.text = 'Restore'
                  this.dataDetail = `data-detail='{"click": [
                    {"dest":"ripple"},
                    {"dest":"menu", "act":"hide"},
                    {"dest":"retailDeleted", "elem":"fullcont", "id":"retailDeleted-fullcont", "act":"restore"}
                  ]}'`
            },
      }],
}
